import React, { useState, useEffect } from 'react';

const VotingNotification = ({ show, onClose }) => {
  // Track if notification should be visible
  const [isVisible, setIsVisible] = useState(false);
  
  // Show notification when 'show' prop changes to true
  useEffect(() => {
    if (show) {
      setIsVisible(true);
      // Auto-hide after 8 seconds, but keep button for manual close
      const timer = setTimeout(() => {
        setIsVisible(false);
      }, 8000);
      
      // Clean up timer if component unmounts
      return () => clearTimeout(timer);
    }
  }, [show]);
  
  // Don't render anything if notification isn't visible
  if (!isVisible) return null;
  
  // Notification popup UI
  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50 w-full max-w-md">
      <div className="bg-indigo-600 text-white p-4 rounded-lg shadow-lg">
        <div className="flex items-start">
          {/* Bell icon */}
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
          </div>
          {/* Notification text */}
          <div className="ml-3 w-0 flex-1 pt-0.5">
            <p className="text-sm font-medium">
              Voting has started!
            </p>
            <p className="mt-1 text-sm">
              Scroll down to rank your choices and submit your vote.
            </p>
          </div>
          {/* Close button */}
          <div className="ml-4 flex-shrink-0 flex">
            <button
              onClick={() => {
                setIsVisible(false);
                if (onClose) onClose();
              }}
              className="bg-indigo-600 rounded-md inline-flex text-white hover:text-indigo-100 focus:outline-none"
            >
              <span className="sr-only">Close</span>
              <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VotingNotification;